import { createAsyncReducer, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: [],
};

export const getFeed = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_FEED"),
});
